import { render, staticRenderFns } from "./TestFingerprintEnroll.vue?vue&type=template&id=0fc0b942&"
import script from "./TestFingerprintEnroll.vue?vue&type=script&lang=js&"
export * from "./TestFingerprintEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports